import { render } from "./SimpleNoteDetailTabDocuments.vue?vue&type=template&id=2b327c97&scoped=true"
import script from "./SimpleNoteDetailTabDocuments.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailTabDocuments.vue?vue&type=script&lang=js"

import "./SimpleNoteDetailTabDocuments.vue?vue&type=style&index=0&id=2b327c97&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b327c97"]])

export default __exports__